module.exports = __webpack_public_path__ + "static/media/pdf-file.6e058c5e.svg";